import React, { createContext, useContext, useState } from 'react';

interface ChatbotContextType {
  isExpanded: boolean;
  setIsExpanded: (val: boolean) => void;
}

const ChatbotContext = createContext<ChatbotContextType | undefined>(undefined);

export const ChatbotProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <ChatbotContext.Provider value={{ isExpanded, setIsExpanded }}>
      {children}
    </ChatbotContext.Provider>
  );
};

export const useChatbotContext = () => {
  const context = useContext(ChatbotContext);
  if (!context)
    throw new Error('useChatbot must be used within ChatbotProvider');
  return context;
};
